import { ListCheck, ShuffleAlt, Tool } from "@mynaui/icons-react";
import { StageDetails } from "../../../types/tournament";
import { Card, Field, FormGrid, Select } from "../../../ui";
import StepHeader from "./StepHeader";

const SCHEDULING_TYPES = [
  { icon: <ShuffleAlt size={32} />, title: "Random", subtitleOptions: { Group: "Generate groups randomly", Knockout: "Generate random matchups" }, value: "random" },
  { icon: <Tool size={32} />, title: "Manual", subtitleOptions: { Group: "Manually assign teams to groups", Knockout: "Manually choose matchups" }, value: "manual" },
  { icon: <ListCheck size={32} />, title: "Seeded", subtitleOptions: { Group: "", Knockout: "Generate seeded matchups" }, value: "seeded" },
];

interface Props {
  stage?: StageDetails;
  selectedType: "manual" | "random" | "seeded";
  setSelectedType: (v: "manual" | "random" | "seeded") => void;
  numOfGroups: number;
  setNumOfGroups: (v: number) => void;
  selectedTeams: string[];
  stageDependent: boolean;
}

const SchedulingTypeStep = ({ stage, selectedType, setSelectedType, numOfGroups, setNumOfGroups, selectedTeams, stageDependent }: Props) => (
  <div className="cs-step scheduling-type-container">
    <StepHeader
      title="Random or Manual Scheduling?"
      subtitle="Would you like to automatically set up the league match schedule or would you prefer to manage it manually?"
    />
    <div className="scheduling-types">
      {SCHEDULING_TYPES.map((type, idx) => {
        const isSeeded = type.value === "seeded";
        const isKnockout = stage?.formatName === "Knockout";
        if (isSeeded && (!isKnockout || (isKnockout && !stageDependent))) return null;
        const active = selectedType === type.value;
        return (
          <button
            type="button"
            className={`type-container ${active ? "active" : ""}`}
            aria-pressed={active}
            key={idx}
            onClick={() => setSelectedType(type.value as "random" | "manual" | "seeded")}
          >
            <span className="type-icon">{type.icon}</span>
            <span className="type-title">{type.title}</span>
            <span className="type-subtitle">{type.subtitleOptions[stage?.formatName as "Group" | "Knockout"]}</span>
          </button>
        );
      })}
    </div>
    {stage?.formatName === "Group" && selectedType === "random" && (
      <Card className="group-container">
        <FormGrid columns={2}>
          <Field label="How many groups in this stage?">
            {(fieldId) => (
              <Select id={fieldId} block value={numOfGroups} onChange={(e) => setNumOfGroups(Number(e.target.value))}>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((item, id) => (
                  <option value={item} key={id}>{item}</option>
                ))}
              </Select>
            )}
          </Field>
          <Field label="Teams per group">
            <p className="cs-static teams-per-group">{Math.floor(selectedTeams.length / numOfGroups)} teams</p>
          </Field>
        </FormGrid>
      </Card>
    )}
  </div>
);

export default SchedulingTypeStep;
